import React, { useContext } from 'react';
import { FloatButton, List, notification } from 'antd';
import { PaymentDetails } from '../reference-book-payment-details.types';
import { localize } from '/react4xp/mixins/helpers';
import { ComponentContext } from '/react4xp/parts/reference-book-payment-details/reference-book-payment-details';
import { CopyOutlined, DownloadOutlined } from '@ant-design/icons';

interface DetailsProps {
    details: PaymentDetails;
}

const Details = ({ details }: DetailsProps) => {
    const { translations } = useContext(ComponentContext);
    const { region, ...fields } = details;
    const data = Object.entries(fields);

    const stringData = data
        .map(([key, value]) => `${localize(key, translations)}: ${value}`)
        .join('\n')
        .trim();

    const handleClipboard = () => {
        navigator.clipboard.writeText(stringData).then(() =>
            notification.info({
                message: localize('notifications.copy', translations),
                duration: 3,
            })
        );
    };

    const handleDownload = () => {
        const element = document.createElement('a');
        element.setAttribute(
            'href',
            `data:text/plain;charset=utf-8,${encodeURIComponent(stringData)}`
        );
        element.setAttribute('download', 'payment-details.txt');
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        element.remove();
    };

    return (
        <List
            itemLayout="horizontal"
            dataSource={data}
            size="small"
            bordered
            style={{ position: 'relative' }}
            renderItem={([key, value]) => (
                <List.Item key={key}>
                    <List.Item.Meta
                        title={localize(key, translations)}
                        description={value}
                    />
                </List.Item>
            )}
        >
            <FloatButton
                icon={<CopyOutlined style={{ color: '#EAB150' }} />}
                tooltip={localize('cta.copy', translations)}
                onClick={handleClipboard}
                style={{ position: 'absolute', bottom: '1rem', right: '1rem' }}
            />

            <FloatButton
                icon={<DownloadOutlined style={{ color: '#EAB150' }} />}
                tooltip={localize('cta.download', translations)}
                onClick={handleDownload}
                style={{ position: 'absolute', bottom: '4.5rem', right: '1rem' }}
            />
        </List>
    );
};

export default Details;
